module.exports = __webpack_public_path__ + "static/media/nrps_logo.8dec692a.png";